import React from 'react';
import { V2FormProvider } from '@abyss/web/ui/FormProvider';
import { Grid } from '@abyss/web/ui/Grid';
import { Box } from '@abyss/web/ui/Box';
import { Heading } from '@abyss/web/ui/Heading';
import { GridBuilder } from '@src/components/global/GridBuilder';
import { V2DateInputRange } from '@abyss/web/ui/DateInputRange';
import { ActivityLogGridController } from './ActivityLogGrid.Controller';
import { dayjs } from '@abyss/web/tools/dayjs';
import { V2TextInput } from '@abyss/web/ui/TextInput';

type ActivityLogGridProps = {
  sourceSessionId?: string | number | null;
};

export const ActivityLogGrid = ({
  sourceSessionId,
}: ActivityLogGridProps = {}) => {
  const { form, gridProps } = ActivityLogGridController({ sourceSessionId });

  return (
    <Box color="$primary2" padding="$md" width="100%">
      <V2FormProvider state={form}>
        <Grid>
          <Grid.Col span={{ xs: '100%' }}>
            <Grid>
              <Grid.Col span={{ xs: 12 }}>
                <Heading display="h4" color="$primary1">
                  Filters
                </Heading>
              </Grid.Col>
              <Grid.Col span={{ xs: 12, md: 6, lg: 2 }}>
                <V2TextInput label="Field" model="field" isClearable />
              </Grid.Col>
              <Grid.Col span={{ xs: 12, md: 6, lg: 2 }}>
                <V2TextInput label="Value" model="value" isClearable />
              </Grid.Col>
              <Grid.Col span={{ xs: 12, md: 6, lg: 3 }}>
                <V2DateInputRange
                  label="Updated By Date Range"
                  model="dateRange"
                  fromFieldConfig={{ hideLabel: true }}
                  toFieldConfig={{ hideLabel: true }}
                  css={{
                    'abyss-date-input-range-root': {
                      gap: '0',
                    },
                    'abyss-date-input-range-inputs-wrapper': {
                      '.abyss-date-input-format-text': {
                        display: 'none',
                      },
                    },
                  }}
                  validators={{
                    validate: {
                      isAfter: (v) => {
                        if (!v || !v.to || !v.from) {
                          return true;
                        }
                        return (
                          dayjs(v.to, 'MM/DD/YYYY').isSameOrAfter(
                            dayjs(v.from, 'MM/DD/YYYY')
                          ) || 'End date should be same or after start date'
                        );
                      },
                    },
                  }}
                />
              </Grid.Col>
            </Grid>
          </Grid.Col>
          <Grid.Col span={{ xs: '100%' }}>
            <GridBuilder props={gridProps} />
          </Grid.Col>
        </Grid>
      </V2FormProvider>
    </Box>
  );
};
